import { Button, InputField } from "@/components";
import { useEffect, useState } from "react";
import { ServiceabilityTable, SpaceWrapper } from "../../components";
import { useApi, useValidation, useFieldError } from "@/";
import ServiceabilitySchema from "../../schemas/ServiceabilitySchema";
import { useSelector } from "react-redux";
const CheckServiceability = () => {
  // Combined state for pincodes
  const [pincodes, setPincodes] = useState({
    pickupPincode: "",
    deliveryPincode: "",
  });
  const [fetchedData, setFetchedData] = useState([]); // State to store the serviceability data
  const { data, loading, error, callApi } = useApi(); // Destructure from useApi
  const { validate, errors } = useValidation(ServiceabilitySchema);
  const [formErrors, setFormErrors] = useState([]);
  const [generalError, setGeneralError] = useState("");
  const getErrorMessage = useFieldError(formErrors);

  const courierSettings = useSelector(
    (state) => state.setting?.settings?.courierManagement
  );
  const serviceableCouriers = useSelector(
    (state) => state.app?.appData?.courier
  );

  useEffect(() => {
    setFormErrors(errors);
  }, [errors]);

  useEffect(() => {
    if (error) setGeneralError(error);
  }, [error]);

  const columns = ["Courier Name", "Surface", "Air"];

  const handleReset = () => {
    setPincodes({ pickupPincode: "", deliveryPincode: "" });
    setFetchedData([]);
    setFormErrors([]);
    setGeneralError("");
  };

  const checkServiceability = async () => {
    const result = validate(pincodes); // Validate the input fields
    console.log("Result:", result);
    if (!result.isValid) return; // If validation fails, return

    const query = {
      ...pincodes,
    };

    try {
      // Trigger the API call and wait for the result
      const response = await callApi(
        "common/serviceable-pincode",
        "GET",
        null,
        query
      );
      console.log("API Response:", response); // Log the response
      if (
        response &&
        response?.data?.availableCourierPartners &&
        Array.isArray(response?.data?.availableCourierPartners)
      ) {
        // Formatting the response to fit the table structure
        console.log(response);
        // Get enabled courier IDs from settings
        const enabledCourierIds = new Set(
          courierSettings
            ?.filter((setting) => setting.isEnabled)
            ?.map((setting) => setting.courierId) || []
        );

        // Create a map of courier names to IDs
        const courierNameToId = {};
        serviceableCouriers?.forEach((courier) => {
          courierNameToId[courier.name] = courier._id;
        });

        const formattedData = response?.data?.availableCourierPartners
          ?.map((services) => ({
            courierName: services.name,
            courierId: courierNameToId[services.name],
            surface: services.pickup && services.delivery ? "Yes" : "No",
            air: services.pickup && services.delivery ? "Yes" : "No",
            pickup: services.pickup ? "Yes" : "No",
          }))
          ?.filter((courier) => {
            // Only show couriers that are enabled in admin settings
            return (
              enabledCourierIds.size === 0 ||
              enabledCourierIds.has(courier.courierId)
            );
          });
        setGeneralError(""); // Reset the general error
        setFetchedData(formattedData); // Update the state with formatted data
      } else {
        console.error("Rates data is not available in the response");
      }
    } catch (err) {
      setGeneralError("An unexpected error occurred. Please try again.", err);
      console.error("Error during API call:", err);
    }
  };

  return (
    <SpaceWrapper>
      <div className="flex flex-col gap-6 w-full h-full pb-20 md:pb-8 max-w-[2000px]overflow-y-auto p-4">
        <div className="flex flex-col gap-1">
          <h1 className="text-headline4 md:text-headline2 font-nunito font-bold text-secondary/95">
            Check Pincode Serviceability
          </h1>
          <p className="text-body2 md:text-subtitle2 pl-1 font-ptsans text-secondary/70 w-full md:w-[43%]">
            Quickly check if your desired pin codes are serviceable for smooth
            and hassle-free deliveries.
          </p>
        </div>
        {generalError && <p className="text-red-600 my-2">{generalError}</p>}
        <div className="flex flex-col gap-6 md:gap-4 w-full md:w-[50%] ">
          <div className="flex flex-col items-center gap-4 mt-2">
            <InputField
              label="Pickup Pincode"
              id="pickupPincode"
              type="number"
              maxlength={6}
              error={getErrorMessage("pickupPincode")}
              value={pincodes.pickupPincode}
              placeholder="Enter pickup pincode"
              onChange={(value) =>
                setPincodes((prev) => ({ ...prev, pickupPincode: value }))
              }
              className="w-full"
            />
            <InputField
              label="Delivery Pincode"
              id="deliveryPincode"
              type="number"
              maxlength={6}
              error={getErrorMessage("deliveryPincode")}
              value={pincodes.deliveryPincode}
              placeholder="Enter delivery pincode"
              onChange={(value) =>
                setPincodes((prev) => ({ ...prev, deliveryPincode: value }))
              }
              className="w-full"
            />
          </div>

          <div className="flex w-full flex-row gap-2 py-5">
            <Button
              onClick={checkServiceability}
              variant="default"
              className="w-[77%]"
            >
              Check Serviceability
            </Button>
            <Button
              onClick={handleReset}
              variant="default"
              className="w-1/5 !bg-secondary/60 hover:!bg-secondary/70"
            >
              Reset
            </Button>
          </div>
        </div>
        <div className="flex flex-col w-full md:w-fit container gap-2">
          {/* <h2 className="text-headline4 pl-1 font-nunito font-bold text-secondaryL/90">
          Available Courier Partners
        </h2> */}
          <ServiceabilityTable
            columns={columns}
            data={fetchedData}
            isService={true}
          />
        </div>
      </div>
    </SpaceWrapper>
  );
};

export default CheckServiceability;
